
import { Inject, Injectable, DOCUMENT } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class HeaderVisiblityService {

  constructor(@Inject(DOCUMENT) private document: Document,) { }

  public collapseHeader(): void {
    this.document.body.style.setProperty('--lms-header-height', `0px`);
    this.document.body.style.setProperty('--lms-header-height-display', `none`);
  }

  public setDefaultHeader(): void {
    this.document.body.style.setProperty('--lms-header-height', `64px`);
    this.document.body.style.setProperty('--lms-header-height-display', `block`);
  }
  
}